import { useLang } from "@/i18n/LanguageContext";
import { TERMS_CONTENT } from "@/i18n/termsContent";
import LegalDocumentPage from "@/components/legal/LegalDocumentPage";

export default function Terms() {
  const { lang } = useLang();
  const content = TERMS_CONTENT[lang] || TERMS_CONTENT.es;

  return <LegalDocumentPage content={content} testId="terms-page" />;
}
